export default "__VITE_ASSET__DCV3SU3l__"